import React from "react";
import { Box, Form, Grid } from "@tiny/components";
import { useEditSegment } from "./EditSegment.hooks";
import EditSegmentHeader from "./EditSegmentHeader";
import ConditionsPanel from "./ConditionsPanel/ConditionsPanel";
import { EditSegmentProvider } from "./EditSegment.context";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import AudiencesPanel from "./AudiencesPanel/AudiencesPanel";
import SummaryPanel from "./SummaryPanel/SummaryPanel";
import SummaryDialog from "./SummaryDialog/SummaryDialog";
import { EditSegmentProps } from "./EditSegment.types";

function EditSegment(props: EditSegmentProps) {
  const editSegmentView = useEditSegment(props);

  const { form } = editSegmentView;

  const { mdUp } = useBreakpoints();

  return (
    <EditSegmentProvider value={editSegmentView}>
      <Box overflow={!mdUp ? "hidden" : undefined}>
        <EditSegmentHeader />
        <Form form={form}>
          <Grid container spacing={mdUp ? 5 : 3}>
            <Grid item flex="1">
              <Grid container spacing={mdUp ? 5 : 3}>
                <Grid item xs={12}>
                  <AudiencesPanel />
                </Grid>
                <Grid item xs={12}>
                  <ConditionsPanel />
                </Grid>
              </Grid>
            </Grid>
            {mdUp && (
              <Grid item flex="0 0 242px">
                <SummaryPanel />
              </Grid>
            )}
          </Grid>
          {!mdUp && <SummaryDialog />}
        </Form>
      </Box>
    </EditSegmentProvider>
  );
}

export default EditSegment;
